<template>
  <div class="welcome-container">
    <MobileHeader @route-change="onRouteChange"></MobileHeader>
    <div class="welcome-swiper-container" style="width: 100%">
       <div class="swiper-wrapper" style="width: 100%">
                <!-- Slides -->
                <div class="swiper-slide" v-for="item in imgList" v-bind:key="item" style="width: 100%" @click="onBannerClick(item)">
                    <img  :src="item" style="height: auto; width: 100%"  />
                </div>
        </div>
    </div>
  </div>
</template>

<script>
import MobileHeader from '../../components/MobileHeader';
import Swiper from 'swiper/bundle';
import {global} from '../../utils/global'

export default {
  name: "Welcome",
  components: {MobileHeader},
  data () {
    return {
      imgList: [
        `${global.RESOURCE_PREFIX}/images/ggj/ggj1.jpg`,
         `${global.RESOURCE_PREFIX}/images/ggj/ggj2.jpg`,
         `${global.RESOURCE_PREFIX}/images/ggj/ggj3.jpg`,
         `${global.RESOURCE_PREFIX}/images/ggj/ggj4.jpg`,
         `${global.RESOURCE_PREFIX}/images/ggj/ggj5.jpg`,
      ]
    }
  },
  mounted () {
    this.initSwiper();
  },
  methods: {
    initSwiper () {
      new Swiper('.welcome-swiper-container', {
                    loop: true,
                    autoplay:true,
                    // If we need pagination
                    pagination: {
                        el: '.swiper-pagination',
                    }
                });
    },
    onRouteChange () {
      this.$emit('route-change');
    },
    onBannerClick () {
      this.$emit('welcome-click');
    }
  }
}
</script>

<style scoped>
.welcome-container {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.welcome-swiper-container {
  width: 100%;
}
</style>